import styled from 'styled-components';

export const Page = styled.div`
	display: flex;
	flex: 1;
`;
